module.exports = __webpack_public_path__ + "img/产出初级品图标.b77945b6.svg";